/**
 * @Description 竞品门店
 */
import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
import { FC, useRef } from 'react';
import styles from '../index.module.less';
import { showMarker } from '@/common/utils/map';
import IconFont from '@/common/components/IconFont';
import { mapContainer } from '..';
export const competitor = 'competitor';
const CompetitorsMarker:FC<any> = ({
  mapIns,
  data,
  contentMarkerRef,
  curDetail,
  setCurDetail,
  handleDetailToNull,
  onClickMarker = () => {}
}) => {
  const massRef = useRef<any>();
  const activeMarker = useRef<any>(null);
  const createContentMarker = (value, activeMarker = null) => {
    const dom = document.querySelector(`.${mapContainer}`);
    var pixel = mapIns.lngLatToContainer([value?.lng, value?.lat]);
    const { x, y } = pixel;
    const offset = [0, 0];
    let topBottom = 'top';
    let leftRight = 'center';
    if (y < 200) {
      topBottom = 'top';
    } else if ((dom?.clientHeight || 0) - y < 200) {
      topBottom = 'bottom';
      offset[1] = 0;
    }
    if (x < 250) {
      leftRight = 'left';
    } else if ((dom?.clientWidth || 0) - x < 250) {
      leftRight = 'right';
    }

    contentMarkerRef.current && mapIns.remove(contentMarkerRef.current);
    contentMarkerRef.current = new window.AMap.Marker({
      position: [value.lng, value.lat],
      anchor: `${topBottom}-${leftRight}`,
      offset,
      zIndex: 60,
      extData: {
        isStore: true, // 是否是经营门店类型，聚合后需要隐藏
        tag: competitor, // 是否是竞品门店
      }
    });
    mapIns.add(contentMarkerRef.current);
    onClickMarker?.();
    showMarker(contentMarkerRef.current,
      <TargetBrand
        data={value}
        mapIns={mapIns}
        marker={contentMarkerRef.current}
        activeMarker={activeMarker}
        handleDetailToNull={handleDetailToNull}
      />);
  };
  const createMass = (data) => {
    const value = data.map((item, index) => ({
      lnglat: [+item.lng, +item.lat],
      detail: item,
      style: index,
      ...item,
    }));

    const styles = value.map(item => ({
      url: item.optimizeLogo || `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_competitor.png`,
      size: [24, 29],
      anchor: 'bottom-center'
    }));

    var mass = new window.AMap.MassMarks(value, {
      opacity: 1,
      cursor: 'pointer',
      style: styles,
      zooms: [1, 20],
      zIndex: 500, // 不然会被showIndoorMap遮挡
    });
    mass.setMap(mapIns);

    mass.on('click', ({ data }) => {
      handleDetailToNull();
      setCurDetail(data);
      // 动态改变 Marker 的图标和尺寸
      activeMarker.current && mapIns.remove(activeMarker.current);
      createActiveMarker(data);
    });
    massRef.current = mass;
  };
  const createActiveMarker = (value) => {
    const logo = value.optimizeLogo || `${process.env.STATIC_RES_DOMAIN}/project-custom/location2.0/map-legend/icon_competitor.png`;
    const marker = new window.AMap.Marker({
      position: [value.lng, value.lat],
      content: `<img class="storeMarkerActive" src="${logo}"/>`,
      anchor: 'bottom-center',
      extData: value
    });
    activeMarker.current && mapIns.remove(activeMarker.current);
    activeMarker.current = marker;
    createContentMarker(value, marker);
    mapIns.add(marker);
  };
  const clearMarker = () => {
    massRef.current?.clear();
    activeMarker.current && mapIns?.remove(activeMarker.current);
  };
  useUpdateEffect(() => {
    if (!mapIns) return;
    clearMarker();
    // data?.map((value) => {
    //   createMarker(value);
    // });
    createMass(data);
  }, [mapIns, data]);

  useUpdateEffect(() => {
    activeMarker.current && mapIns.remove(activeMarker.current);
    if (data?.findIndex((item) => item.id === curDetail?.id) !== -1) {
      createContentMarker(curDetail);
      createActiveMarker(curDetail);
    }
  }, [curDetail]);

  useUpdateEffect(() => {
    const tag = contentMarkerRef.current?.getExtData()?.tag;
    if (tag === competitor && !data?.length) {
      contentMarkerRef.current && mapIns?.remove(contentMarkerRef.current);
    }
  }, [data]);

  return <div>

  </div>;
};

const TargetBrand = ({
  data,
  mapIns,
  marker,
  activeMarker,
  handleDetailToNull
}) => {

  return <div className={styles.competitorBrand}>
    <IconFont
      iconHref={'iconic_close_colour_seven'}
      className={styles.closeIcon}
      onClick={() => {
        handleDetailToNull();
        mapIns.remove(marker);
        mapIns.remove(activeMarker);
      }}
    />
    <div className={styles.name}>
      {data?.logo ? <img src={data?.logo}/> : <></>}
      {data?.name}
    </div>
    <div className={styles.box}>
      {data?.openTypeName ? <div className='mt-8'>
        <span className='c-999'>开店类型：</span>
        <span>{data?.openTypeName || '-'}</span>
      </div> : <></>}
      {data?.statusName ? <div className='mt-4'>
        <span className='c-999'>营业状态：</span>
        <span>{data?.statusName || '-'}</span>
      </div> : <></>}
      {data?.typeName ? <div className='mt-4'>
        <span className='c-999'>门店类型：</span>
        <span>{data?.typeName || '-'}</span>
      </div> : <></>}
      {data?.function ? <div className='mt-4'>
        <span className='c-999'>门店功能：</span>
        <span>{data?.function || '-'}</span>
      </div> : <></>}
      {data?.address ? <div className='mt-4'>
        <span className='c-999'>地址：</span>
        <span>{data?.address || '-'}</span>
      </div> : <></>}
    </div>
  </div>;
};
export default CompetitorsMarker;
